import React from 'react';
import styled from 'styled-components';
import { Img } from 'components/common/Img';
import { Text } from 'styles';

export function MainBusiness({ list, navigate }) {
  return (
    <Container>
      {list.map((item, index) => (
        <Wrap key={`item_${index}`} onClick={() => navigate('/company')}>
          <Img src={item.img} alt={`팜인 ${item.subject} - ${item.title.replace(/\n/g, ' ')}`} $width="100%" $objectFit="cover" />
          <TextDiv>
            <h4>{item.title}</h4>
            <h5>{item.subject}</h5>
            <div className="desc">
              <Text $color="white" $type="b7">
                {item.desc}
              </Text>
            </div>
          </TextDiv>
          <ImgDim />
        </Wrap>
      ))}
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  & > div:nth-child(1) {
    border-radius: 16px 0 0 0;
  }

  & > div:nth-last-child(1) {
    border-radius: 0 0 16px 0;
  }

  @media ${({ theme }) => theme.device.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Wrap = styled.div`
  position: relative;
  flex: 2.5;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1);
  height: 627px;
  cursor: pointer;

  &:hover {
    flex: 6;
  }

  @media ${({ theme }) => theme.device.tablet} {
    height: 344px;
  }
`;

const TextDiv = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 1;
  white-space: pre;
  text-align: center;

  h4 {
    transition: all 350ms ease;
    font-size: 1.5rem;
    line-height: 1.5;
  }

  h5 {
    font-size: 1.25rem;
    line-height: 1.5;
    font-weight: 400;
  }

  .desc {
    display: none;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      h4 {
        font-size: 2.375rem;
        line-height: 1.5;
      }
      .desc {
        display: block;

        &::before {
          content: '';
          display: inline-block;
          width: 100px;
          height: 2px;
          margin: 8px 0;
          background-color: rgba(255, 255, 255, 0.33);
        }
      }
    }
  }

  @media ${({ theme }) => theme.device.tablet} {
    .desc {
      display: block;

      &::before {
        content: '';
        display: inline-block;
        width: 100px;
        height: 2px;
        margin: 8px 0;
        background-color: rgba(255, 255, 255, 0.33);
      }
    }
  }
`;

const ImgDim = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(23, 23, 23, 0.4);
  position: absolute;
  top: 0;
`;
